// Use this file to export React client components (e.g. those with 'use client' directive) or other non-server utilities

export * from "./lib/SplitTreatment";
